// extracted by mini-css-extract-plugin
export default {"separator":"styles_separator__MCs5o","flex1":"styles_flex1__Co9jy"};